import * as React from 'react';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { IModalAction } from 'models/modal';
import { showModal, closeModal } from 'modules/modal';
import { IUserPreferences } from 'models/user/userpreferences';
import { browserHistory } from 'react-router';

interface IProps {
	userPreferences?: IUserPreferences;
	routing?: any;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
}

@connect(
	(store: IStore) => ({
		userPreferences: store.userPreferences,
		routing: store.routing,
	}),
	(dispatch) => ({
		dispatch,
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	}),
)
class LoginFinished extends React.Component<IProps, { hasOpened: boolean }> {
	constructor(props) {
		super(props);

		this.state = {
			hasOpened: false,
		};
	}

	public componentDidUpdate() {
		const { givenName, familyName, phoneNumber, callingCodeKey, profilePicture } = this.props.userPreferences;
		const { returnUrl } = this.props?.routing?.locationBeforeTransitions?.query || {};
		const lastLocation = returnUrl && returnUrl.replaceAll('?returnUrl=', '');
		const pictureId = profilePicture?.split('/img/').pop().split('.')[0]; // Get the picture id from the url

		if (lastLocation !== undefined) {
			browserHistory.push(lastLocation);
		}
		if (!this.state.hasOpened) {
			if (givenName === null || familyName === null || phoneNumber === null) {
				this.setState({ hasOpened: true });
				this.props.showModal('OnboardingQuiz', {
					closeModal: this.props.closeModal,
					showHeaderCloseButton: false,
					showModal: this.props.showModal,
					userProps: {
						givenName,
						familyName,
						phoneNumber,
						callingCodeKey,
						picture: profilePicture,
						pictureId: pictureId,
					},
					lastLocation: lastLocation,
				});
			}
		}
	}

	public render() {
		return <></>;
	}
}
export { LoginFinished };
